import "./_spot-button.scss"
import * as trackingHelper from "../../helpers/tracking"

export default class SpotButtonsModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.spotButtons = elem.querySelectorAll(".spot-button")
    self.init()
    return self
  }

  init() {
    const self = this
    self.addEventListeners()
    self.trackImpressions()
  }

  addEventListeners() {
    const self = this
    if (self.spotButtons && self.spotButtons.length > 0) {
      self.spotButtons.forEach((elem, index) => {
        elem.addEventListener("click", (e) => this.trackClick(e, index))
      })
    }
  }

  trackImpressions() {
    const self = this
    if (self.spotButtons && self.spotButtons.length > 0) {
      var spotButtons = []
      self.spotButtons.forEach((spotButton, index) => {
        // if there's a creative available, we know it's the shop frontpage, if not, it's a category page
        const creative = spotButton.dataset.creative ? spotButton.dataset.creative : "category page - content box"
        spotButtons.push({
          id: spotButton.dataset.id,
          name: spotButton.dataset.name,
          creative: creative,
          position: index + 1,
        })
      })

      trackingHelper.highlightedContentImpressions(spotButtons)
    }
  }

  trackClick(e, index) {
    var element = e.target
    const creative = element.dataset.creative ? element.dataset.creative : "category page - content box"
    var elements = [
      {
        id: element.dataset.id,
        name: element.dataset.name,
        creative: creative,
        position: index + 1,
      },
    ]

    trackingHelper.highlightedContentClicks(elements)
  }
}
